// extracted by mini-css-extract-plugin
module.exports = {"header":"GridView_header__pC5Ab","title":"GridView_title__wA8qo","description":"GridView_description__lK3qO","link":"GridView_link__2tfXn"};